module.exports = __webpack_public_path__ + "static/media/logo.9c372ae0.svg";